
export const AUTH_ROUTE_NAME = {
  SIGNUP: 'signup',
  SIGNIN: 'signin',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  VERIFY_EMAIL: 'verify-email',
  ACTIVE_EMAIL: 'active-email',
  SETUP_PASSWORD: 'setup-password',
  PROFILE: 'profile',
  AUTH: 'auth'
};

export const MAIN_ROUTE_NAME = {
  HOME: 'home',
};

export const EMPLOYEE_ROUTE_NAME = {
  LIST_EMPLOYEE: 'list-employee',
  PICK_EMPLOYEES: 'pick-employees',
};

export const CUSTOMER_REVIEW_ROUTE_NAME = {
  CUSTOMER_REVIEW: 'customer-review',
};

export const REVIEW_ROUTE_NAME = {
  LIST_REVIEW: 'list-review',
};

export const TURN_TRACKER_ROUTE_NAME = {
  TURN_TRACKER: 'turn-tracker',
};

export const SERVICE_ROUTE_NAME = {
  LIST_SERVICE: 'list-service',
};

export const STORE_ROUTE_NAME = {
  ADD_STORE: 'add-store',
  STORE_SETTINGS: 'store-settings'
};

export const PROMOTION_ROUTE_NAME = {
  PROMOTION: 'promotion',
};
